import { Injectable, OnInit } from "@angular/core";
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
	providedIn: "root",
})
export class AreaFuncionalGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) {
		console.log(">>AreaFuncionalGuard.constructor()::");
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		let url: string = state.url;
		console.log(">>AreaFuncionalGuard.canActivate():: url: %s", url);
		// Se cargan los roles del usuario y luego se hace el checkeo de si puede entrar a la URL requerida
		return new Observable<boolean>((observer) => {
			console.log(">> AreaFuncionalGuard::canActivate() - Inicio");
			let userName = this.authService.getUsername();
			this.authService.getUserAreasFuncionales(userName).subscribe(
				(responseUsrAreas: any) => {
					if(responseUsrAreas && responseUsrAreas.areasFuncionales){
					//	console.log("responseUsrAreas.areasFuncionales: " + responseUsrAreas.areasFuncionales);
						this.authService.getUser().areasFuncionales = [];
						for (let i = 0; i < responseUsrAreas.areasFuncionales.length; i++) {
							const element = responseUsrAreas.areasFuncionales[i];
							this.authService.getUser().areasFuncionales.push(element);
						} //for
					//	console.log("this.authService.getUser().areasFuncionales: " + this.authService.getUser().areasFuncionales);
					}
					observer.complete();
				},
				(err) => {
					console.log(err);
					observer.next(false);
					observer.complete();
				}
			);
		});
	}
}